import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import Avatar from '../common/Avatar';
import { toast } from 'react-toastify';

import UserService from '../../services/user.service';
import { ucFirst } from '../../helpers/hcutils';
import AppContext from '../../context/Context';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import './a.css';

const ProfileDropdown = ({ currentuser, setCurrentUser }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);
  const [currentuserdata, setCurrentUserData] = useState(null);
  const [isLoadedUserData, setIsLoadedUserData] = useState(false);
  const {
    setReportCompanyFilter,
    setReportPeriodType,
    setReportSelectedOrganizationId,
    setReportSelectedOrganizationName,
    setReportExamResultFilter
  } = useContext(AppContext);

  const location = useLocation();

  const getUser = id => {
    UserService.find(id)
      .then(response => {
        setCurrentUserData(response.data);
        setIsLoadedUserData(true);
      })
      .catch(error => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(`Try again! ${resMessage}`);
      });
  };

  const formatUserName = () => {
    let fullname = '';
    if (isLoadedUserData && currentuserdata) {
      if (
        currentuserdata.firstname &&
        currentuserdata.firstname.length > 0 &&
        currentuserdata.lastname &&
        currentuserdata.lastname.length > 0
      ) {
        fullname = currentuserdata.firstname + ' ' + currentuserdata.lastname;
      } else if (currentuserdata.firstname && currentuserdata.firstname.length > 0) {
        fullname = currentuserdata.firstname;
      } else {
        fullname =
          currentuserdata.lastname && currentuserdata.lastname.length > 0 ? currentuserdata.lastname : 'Health Care';
      }
    }
    return fullname;
  };

  useEffect(() => {
    if (location.pathname.includes('guru')) return;
    if (currentuser) getUser(currentuser.id);
  }, [currentuser, location.pathname]);

  return (
    <Dropdown nav inNavbar isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle nav className="pr-0">
        <div className="d-flex align-items-center">
          {/* Bloque de texto (username y rol) con orden 1 */}
          <div className="d-none d-md-block order-1">
            <h5 className="mb-0 fs--1">{ucFirst(currentuser.roles[0])}</h5>
            <h5 className="mb-0 fs--1">{currentuser.username}</h5>
          </div>
          {/* Avatar con orden 2 */}
          {isLoadedUserData && (
            <Avatar name={formatUserName()} className="order-2 ml-2" />
          )}
        </div>
      </DropdownToggle>

      <DropdownMenu right className="dropdown-menu-card profile-dropdown-menu">
        <div className="bg-white rounded-soft py-2">
          <DropdownItem tag={Link} to="/pages/profile">
            Profile
          </DropdownItem>
          <DropdownItem tag={Link} to="/pages/about">
            About
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem tag={Link} to="/pages/settings">
            Settings
          </DropdownItem>
          <DropdownItem
            tag={Link}
            to={
              currentuser.roles[0] === 'kiosk'
                ? '/kiosk/login'
                : currentuserdata?.department?.organization?.type?.toLowerCase() === 'truck'
                ? '/guru/login'
                : '/authentication/login'
            }
            onClick={() => {
              if (currentuser) {
                const isKiosk = currentuser.roles[0] === 'kiosk';
                const isTruck = currentuserdata?.department?.organization?.type?.toLowerCase() === 'truck';
                if (isKiosk) {
                  window.history.pushState({}, '', '/kiosk/login');
                } else if (isTruck) {
                  window.history.pushState({}, '', '/guru/login');
                } else {
                  window.history.pushState({}, '', '/authentication/login');
                }
                setCurrentUser(null);
                setReportCompanyFilter('');
                setReportPeriodType('day');
                setReportSelectedOrganizationId(0);
                setReportSelectedOrganizationName('');
                setReportExamResultFilter('');
              }
            }}
          >
            Logout
          </DropdownItem>
        </div>
      </DropdownMenu>
    </Dropdown>

  );
};

export default ProfileDropdown;
